const IDP_CALLBACK_BASE = '/idp';

export const AUTHENTICATION_ROUTES = {
  /**
   * Interstitial shown when the user requested a module they cannot access but
   * has access to others. It informs them of the denied module and redirects to
   * an accessible one, with both an automatic countdown and a manual button.
   */
  ACCESS_REDIRECT: '/access-redirect',
  FORGOT_PASSWORD: '/forgot-password',
  IDP_CALLBACK: `${IDP_CALLBACK_BASE}/:nonceToken?/:systemId?`,
  IDP_CALLBACK_BASE,
  LOGIN: '/login',
  LOGOUT: '/logout',
  /**
   * Landing page shown after a successful login when the authenticated user has
   * access to no modules at all. It explains the situation and lets the user log
   * out, instead of dropping them into a module they cannot use.
   */
  NO_MODULE_ACCESS: '/no-module-access',
  OAUTH_CALLBACK: '/oauth-callback',
  UPDATE_CREDENTIALS: '/update-credentials',
  UPDATE_CREDENTIALS_WITH_TOKEN: '/update-credentials/:token'
} as const;

// Route parameter interfaces - co-located with their corresponding routes
export interface IdpCallbackRouteParams {
  nonceToken?: string;
  systemId?: string;
}

export interface UpdateCredentialsRouteParams {
  token?: string;
}
